const getCookieValue = (key) => {
	const b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
	return b ? b.pop() : '';
};

const removeCookie = (key) => (document.cookie = `${key}=;path=/;domain=.qiagen.com;`);

export {getCookieValue, removeCookie};
